import { render, staticRenderFns } from "./HubSelect.vue?vue&type=template&id=33e4b80e&scoped=true&"
import script from "./HubSelect.vue?vue&type=script&lang=ts&"
export * from "./HubSelect.vue?vue&type=script&lang=ts&"
import style0 from "./HubSelect.vue?vue&type=style&index=0&id=33e4b80e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e4b80e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
